import React, { useEffect, useState, useCallback } from "react";
import Layout from "containers/LayoutV2";
import configsRole from "utils/configsRole";
import "react-dropdown/style.css";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { TableDanhSach } from "./TableDanhSach";
import KiemKeApi from "service/BaoCao/KiemKeApi";
import StoreApi from "service/phanQuyenApi";
import { format } from "date-fns";
import UserApi from "service/userApi";

export const KiemKe = () => {
  const initPhanQuyen = {
    kiemke: false,
    themmoi: false,
    sua: false,
    chitiet: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [loading, setLoading] = useState(true);
  const initialDataSearch = {
    dtFromTime: null,
    dtToTime: null,
    iPageIndex: 1,
    iPageSize: 20,
  };
  const [dataSearch, setDataSearch] = useState(initialDataSearch);
  const [listDanhSach, setListDanhSach] = useState({ List: [], iTotal: 0 });
  const [isLoadingList, setIsLoadingList] = useState(false);

  const handleGetData = useCallback((searchParams) => {
    setIsLoadingList(true);
    const params = {
      ...searchParams,
      dtFromTime: searchParams.dtFromTime
        ? format(searchParams.dtFromTime, "dd/MM/yyyy")
        : null,
      dtToTime: searchParams.dtToTime
        ? format(searchParams.dtToTime, "dd/MM/yyyy")
        : null,
    };
    KiemKeApi.getList(params)
      .then((res) => {
        if (res && res.status === 200) {
          setListDanhSach({
            List: res.data.List || [],
            iTotal: res.data.iTotal || 0,
            iPageSize: params.iPageSize || 20,
            iPageIndex: params.iPageIndex || 1,
          });
        } else {
          setListDanhSach({ List: [], iTotal: 0 });
        }
      })
      .catch(() => {
        setListDanhSach({ List: [], iTotal: 0 });
      })
      .finally(() => setIsLoadingList(false));
  }, []);

  const handleReloadList = () => {
    handleGetData(dataSearch);
  };

  React.useEffect(() => {
    if (phanQuyen.kiemke) {
      handleReloadList();
    }
  }, [phanQuyen.kiemke]);

  const LoadPhanQuyen = () => {
    StoreApi.getAllQuyen()
      .then((response) => {
        if (response.status === 200) {
          const getRole = (code) =>
            response.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase()
            );
          setPhanQuyen({
            kiemke: getRole(configsRole.sRole.kiemkequy),
            themmoi: getRole(configsRole.sRole.kiemkequy_themmoi),
            sua: getRole(configsRole.sRole.kiemkequy_sua),
            chitiet: getRole(configsRole.sRole.kiemkequy_chitiet),
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    document.title = "Kiểm kê quỹ | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);

  // if (loading) return null; loi menu

  return (
    <Layout>
      {phanQuyen.kiemke === true ? (
        <div id="form-repeater" className="p-1">
          <div
            className="breadcrumb-new hidden-mobile-main"
            style={{ marginBottom: "5px" }}
          >
            <div className="row header justify-content-start">
              <img
                src="/app-assets/images/icon-thong-ke.png"
                alt="Mẫu hợp đồng"
              />
              <h1 className="text-info-home">Danh sách Kiểm kê quỹ</h1>
            </div>
          </div>
          <div>
            <SearchBarDesktop
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onSearch={handleGetData}
            />
            <TableDanhSach
              phanQuyen={phanQuyen}
              listDanhSach={listDanhSach}
              isLoading={isLoadingList}
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onReload={handleReloadList}
              onSearch={handleGetData}
            />
          </div>
        </div>
      ) : (
        <div id="form-repeater" className="p-1">
          <div
            className="breadcrumb-new hidden-mobile-main"
            style={{ marginBottom: "5px" }}
          >
            <div className="row header justify-content-start">
              <img
                src="/app-assets/images/icon-thong-ke.png"
                alt="Mẫu hợp đồng"
              />
              <h1 className="text-info-home">Danh sách Kiểm kê quỹ</h1>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </Layout>
  );
};
